export const CONFIRM_REGISTRATION_REQUEST = 'CONFIRM_REGISTRATION_REQUEST';
export const CONFIRM_REGISTRATION_SUCCESS = 'CONFIRM_REGISTRATION_SUCCESS';
export const CONFIRM_REGISTRATION_FAILURE = 'CONFIRM_REGISTRATION_FAILURE';

export const RESEND_CONFIRMATION_EMAIL_REQUEST = 'RESEND_CONFIRMATION_EMAIL_REQUEST';
export const RESEND_CONFIRMATION_EMAIL_SUCCESS = 'RESEND_CONFIRMATION_EMAIL_SUCCESS';
export const RESEND_CONFIRMATION_EMAIL_FAILURE = 'RESEND_CONFIRMATION_EMAIL_FAILURE';

export const RESET_CONFIRMATION_EMAIL_SUCCESS = 'RESET_CONFIRMATION_EMAIL_SUCCESS';
